export default "__VITE_ASSET__BbQ4Jmj4__"